import React, { Component, Dispatch } from 'react';
import { INewPassword } from '../../models/pages/login';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions/login';
import { Input } from '../../components/input/text/main';
import Loading from '../../components/loading/loading';
import Translator from '../../core/i18n';
import { Log } from 'ng2-logger';
import { newNotification } from '../../store/actions/core';

const T = Translator.create();
const _logger = Log.create('set-new-password.tsx');
class NewPassword extends React.Component<INewPassword> {
    public userName: string | null = null;
    public passwordVerfiy: string | null = null;
    public writedPassword: string | null = null;
    public refForm: HTMLFormElement | null = null;
    public initializeStatus: boolean = false;

    
    inputRef1: Input | null = null;
    inputRef2: Input | null = null;

    public state = {
        isInput1Valid: false,
        isInput2Valid: false
    }

    constructor(props: INewPassword) {
        super(props);
    }

    public componentDidMount = () => {
        if (this.props.recoveryPasswordToken) {
            this.props.dispatch(Actions.myForgotPasswordCheckTokenGetAction(this.props.recoveryPasswordToken));
        }
    }

    public componentDidUpdate = () => {
        this.initializeStatus = true;
    }

    getValidation = () => {
        return this.writedPassword === this.passwordVerfiy
    }

    public changePassword = (event: any) => {
        event.preventDefault();
        this.validateInput1();
        this.validateInput2();
        if (this.refForm?.checkValidity() && this.state.isInput1Valid && this.state.isInput2Valid) {
            if (this.writedPassword && this.props.recoveryPasswordToken) {
                
                let isEqual = this.getValidation();
                if(isEqual){
                    this.props.dispatch(Actions.myForgotPasswordSaveGetAction(this.writedPassword, this.props.recoveryPasswordToken, this.props.username));
                }else{
                    this.props.dispatch(newNotification(T.t('r_my_forgot_password_paswords_dont_match_error_message'), '', '', 'topRight', 'error'));
                }
                
            }
        }
    }

    public onChangePassword = (event: string) => {
        this.writedPassword = event;
    };

    public onChangeVerifyPassword = (event: string) => { this.passwordVerfiy = event; };

    public onKeyUpChangePassword = (event: any) => {
        event.preventDefault();
        this.validateInput1();
        this.validateInput2();
        if (event.keyCode === 13) {
            if (this.refForm?.checkValidity() && this.state.isInput1Valid && this.state.isInput2Valid) {
                if (this.writedPassword && this.props.recoveryPasswordToken) {
                    
                    let isEqual = this.getValidation();
                    if(isEqual){
                        this.props.dispatch(Actions.myForgotPasswordSaveGetAction(this.writedPassword, this.props.recoveryPasswordToken, 'myForgotPasswordSaveGetAction', 'get'));
                    }else{
                        this.props.dispatch(newNotification(T.t('r_my_forgot_password_paswords_dont_match_error_message'), '', '', 'topRight', 'error'));
                    }
                }
            }
        }
    }

    validateInput1 = () => {
        let formIsValid = false;

        if(this.inputRef1){
            if(this.inputRef1.onValid){
                let isValid = this.inputRef1.onValid();
                if(isValid){
                    formIsValid = true;

                }
            }
        }
        this.setState({ isInput1Valid: formIsValid });
    }

    validateInput2 = () => {
        let formIsValid = false;

        if(this.inputRef2){
            if(this.inputRef2.onValid){
                let isValid = this.inputRef2.onValid();
                if(isValid){
                    formIsValid = true;

                }
            }
        }
        this.setState({ isInput2Valid: formIsValid });
    }

    public onLoginPageClick = () => {
        this.props.dispatch(Actions.setCurrentPage('Login', ''));
        window.history.pushState(null, '', window.appSettings.DEFAULT_URL);
    };

    public render() {
        return (
            <div>
                <Loading spinnerId={'myForgotPasswordSaveGetAction'} text={'İşleminiz yapılıyor...'} />
                {
                    (
                        <div className="animated fadeIn" >
                            <h1>{T.t('r_my_forgot_password_new_password_title')}</h1>
                            <p>{T.t('r_my_forgot_password_new_password_comment')}</p>
                            <p>{(this.props.passwordStrength) ? this.props.passwordStrength : ''}</p>
                            <form ref={e => this.refForm = e} noValidate={false} onSubmit={this.changePassword}>
                                <Input type="password"
                                    required={true}
                                    onChange={this.onChangePassword}
                                    placeHolder={T.t('r_my_forgot_password_input')}
                                    onkeyUp={this.onKeyUpChangePassword}
                                    ref={(ref: any) => this.inputRef1 = ref}
                                    noneAlphanumericCharacters={this.props.alphaNumericLength}
                                    maxLenght={50}
                                    minLenght={(this.props.minPasswordLength) ? this.props.minPasswordLength : 8}
                                />
                                <Input type="password"
                                    required={true}
                                    onChange={this.onChangeVerifyPassword}
                                    onkeyUp={this.onKeyUpChangePassword}
                                    placeHolder={T.t('r_my_forgot_password_input_again')}
                                    ref={(ref: any) => this.inputRef2 = ref}
                                    maxLenght={50}
                                    noneAlphanumericCharacters={this.props.alphaNumericLength}
                                    minLenght={(this.props.minPasswordLength) ? this.props.minPasswordLength : 8}
                                />
                                <div className="row align-items-center">
                                    <div className="col">
                                        <a className='d-flex align-items-center gap-2' onClick={this.onLoginPageClick}><i className="material-icons mr-3">keyboard_backspace</i>{T.t('r_gen_login')}</a>
                                    </div>
                                    <div className="col text-right">
                                        <button type='submit' className="btn btn-primary d-flex align-items-center gap-2">{T.t('r_my_forgot_password_input_save_button')}<i className="material-icons">arrow_forward</i></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: INewPassword) => {
    if (!state) {
        return ownProps;
    }
    // tslint:disable-next-line: one-variable-per-declaration
    const newProps: INewPassword = Object.assign({}, ownProps, {
        notFoundToken: state.login.login.notFoundToken,
        expiredToken: state.login.login.expiredToken,
        currentPage: state.login.login.currentPage,
        newPasswordLoading: state.login.login.newPasswordLoading,
        recoveryPasswordToken: state.login.login.recoveryPasswordToken,
        username: state.login.identitiy.userName,
        minPasswordLength: state.login.login.requisiteMinPasswordLength,
        passwordStrength: state.login.login.passwordStrength,
        alphaNumericLength: state.login.login.minNonAlphanumericLength,
        newPasswordSaveStatus: state.login.login.newPasswordSaveStatus
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => ({
    dispatch
});

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        // next.login.login.newPasswordLoading === prev.login.login.newPasswordLoading &&
        next.login.login === prev.login.login &&
        next.login.identitiy.userName === prev.login.identitiy.userName &&
        next.login.login.recoveryPasswordToken === prev.login.login.recoveryPasswordToken &&
        next.login.login.currentPage === prev.login.login.currentPage
    );
    return ret;
};

const CNewPassword = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(NewPassword);

export default CNewPassword;
